import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './template.vdt';
import { useConfigContext } from '../config';
export var Footer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Footer, _Component);
  function Footer() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Footer.prototype;
  _proto.getClassNames = function getClassNames() {
    var _ref;
    var _this$get = this.get(),
      className = _this$get.className;
    var k = this.config.k;
    return _ref = {}, _ref[k + "-layout-footer"] = true, _ref[className] = className, _ref;
  };
  return Footer;
}(Component);
Footer.template = template;